import { z } from 'zod';
export const resolveOrgTreeItemIdsDef = {
    name: 'resolveOrgTreeItemIds',
    requestSchema: z.object({ ids: z.string().array() }),
    responseSchema: z.array(z.string()),
};
